import React, { useEffect, useState } from "react";
import { MachineryMap } from "./map";
import { useGetTransportRegisterByCategoryQuery, useGetTransportRegisterByTypeQuery, TransportRegisterFilter } from "./api/api";
import { YearCategory, CategoryData } from "./api/types";

import { useGetTerritorialUnitsGetpolygonsListQuery } from "../../../redux/api/handBooksApi/territorialUnitsApi";
import { EntTerritorialUnitsFilter } from "../../../models/filters/territorialUnitsFilter";
import { TrailedEquipment } from "./Trailedequipment";
import { Button, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ReportTransportModal from "../../../pages/admin/mechanization/transport/ReportTransportModal";
import { useGetReportTransportMutation } from "../../../redux/api/transport/transportApi";
import styles from "./styles.module.css";
import { Generalstatisticstable } from "./Generalstatisticstable";
import { DynamicsByYears } from "./Dynamicsbyyears";
import { PreloaderSvg } from "../../preloaderSvg/PreloaderSvg";
import SelectYear from "../../selects/SelectYear";

interface AgriculturalmachineryProps {
  latitude: number;
  longitude: number;
}

export const Agriculturalmachinery: React.FC<AgriculturalmachineryProps> = ({
  latitude,
  longitude,
}) => {
  const { t, i18n } = useTranslation();

  const [selectedYear, setSelectedYear] = useState<number | null>(2025);
  const [selectedRegionId, setSelectedRegionId] = useState<number>();
  const [selectedRegionName, setSelectedRegionName] = useState<string>("");
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [getTransportReport] = useGetReportTransportMutation();
  const [getTransportReportWork] = useGetReportTransportMutation();
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [reportType, setReportType] = useState<'transportAll' | 'transportWork' | null>(null);

  const tableFilter: TransportRegisterFilter = {
    page: 1,
    size: 1000,
    year: selectedYear || undefined
  };

  const mapFilter: TransportRegisterFilter = {
    page: 1,
    size: 1000,
    territorialUnitIds: selectedRegionId ? [selectedRegionId] : undefined,
    year: selectedYear || undefined
  };

  const polygonsFilter = new EntTerritorialUnitsFilter({
    page: 1,
    size: 15,
  });

 
  const {
    data: mapData,
    error: mapError,
    isLoading: mapLoading,
    isFetching: mapFetching
  } = useGetTransportRegisterByCategoryQuery(mapFilter);


  const {
    data: tableData,
    error: tableError,
    isLoading: tableDataLoading,
    isFetching: tableDataFetching
  } = useGetTransportRegisterByCategoryQuery(tableFilter);

  const {
    data: typeData,
    error: typeError,
    isLoading: typeLoading,
    isFetching: typeFetching
  } = useGetTransportRegisterByTypeQuery(mapFilter);

  const {
    data: polygonsData,
    isLoading: polygonsLoading
  } = useGetTerritorialUnitsGetpolygonsListQuery(polygonsFilter);

  const yearData = tableData?.res?.find((item: YearCategory) => item.year === 2025);
  const mountedImplementsData = yearData?.categories?.find(
    (cat: CategoryData) => cat.category.alias === "mounted_implements"
  );

  const getReportAll = async (payload: { manufactureYear: number; }): Promise<Blob> => {
    return await getTransportReport({ ...payload, language: i18n.language }).unwrap();
  };

  const getReportWork = async (payload: {
    manufactureYear: number;
    seasonStatus?: boolean | null;
    checkStatus?: boolean | null;
  }): Promise<Blob> => {
    return await getTransportReportWork({ ...payload, language: i18n.language }).unwrap();
  };

  const openReportModal = (type: 'transportAll' | 'transportWork') => {
    setReportType(type);
    setShowReportModal(true);
  };

  useEffect(() => {
    setIsTableLoading(mapFetching || typeFetching);
  }, [mapFetching, typeFetching]);

  useEffect(() => {
    if (mapError || typeError) {
      console.error('Error:', mapError || typeError);
    }
  }, [mapError, typeError]);

  const isLoading = mapLoading || typeLoading || polygonsLoading;

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <PreloaderSvg />
            </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div className={styles.title_header}>
          <h1>{t('Agricultural machinery main')}</h1>
          <div>
            <Button style={{ marginLeft: '5px' }} type="primary" icon={<img src="../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />}
              onClick={() => openReportModal('transportAll')}>
              {t('reports.report_by_transport_all')}
            </Button>
            <Button style={{ marginLeft: '5px' }} type="primary" icon={<img src="../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />}
              onClick={() => openReportModal('transportWork')}>
              {t('reports.report_by_transport_work')}
            </Button>

            <ReportTransportModal
              title={reportType === 'transportAll' ? t('reports.report_by_transport_all') : t('reports.report_by_transport_work')}
              type={reportType}
              getReport={reportType === 'transportAll' ? getReportAll : getReportWork}
              show={showReportModal}
              onHide={() => setShowReportModal(false)}
            />
          </div>
        </div>
        <div className={styles.title_inner}>
          <img src="../homeicon.svg" alt="home" />
          <p>{t('Home')}</p>
          <img src="../arrowright.svg" alt="arrow" />
          <p>{t('Mechanization and innovations')}</p>
          <img src="../arrowright.svg" alt="arrow" />
          <span className={styles.namepage}>{t('Agricultural machinery main')}</span>
        </div>
      </div>
      <div className={styles.bottomSection}>
        <div className={styles.statsContainer}>
          <Generalstatisticstable 
            data={tableData}
          />
        </div>
        <div className={styles.mapContainer}>
          <div className={styles.yearSelectorOverlay}>
            <SelectYear
              value={selectedYear}
              onChange={(year) => setSelectedYear(year)}
            />
          </div>
          <MachineryMap
            latitude={latitude}
            longitude={longitude}
            categoryData={mapData}
            typeData={typeData}
            isLoading={isTableLoading}
            polygonsData={polygonsData}
            onRegionClick={(regionId: number, regionName: string) => {
              setSelectedRegionId(regionId);
              setSelectedRegionName(regionName);
            }}
            selectedRegionName={selectedRegionName}
            initialRegionId={selectedRegionId}
          />
        </div>
      </div>
      <div className={styles.dynamicsContainer}>
        <DynamicsByYears data={tableData} />
      </div>
      <TrailedEquipment categoryData={tableData} />
    </div>
  );
};
